import ui from 'veui/managers/ui';

ui.defaults(
    {
        ui: {
        }
    },
    'accordion'
);
